__turbopack_context__.v({
  "addons-box-header-banner-icon": "EmailSignatureEditorAddonsBannerBox-module-scss-module__AuAHdG__addons-box-header-banner-icon",
  "addons-images-field": "EmailSignatureEditorAddonsBannerBox-module-scss-module__AuAHdG__addons-images-field",
  "image-editor-framer-container": "EmailSignatureEditorAddonsBannerBox-module-scss-module__AuAHdG__image-editor-framer-container",
});
